import { PARTNER_BASIC_INFO_TRANSLATIONS_NAMESPACE } from '../../../translations'

export const TRANSLATION_KEYS = {
  fieldLabel: `${PARTNER_BASIC_INFO_TRANSLATIONS_NAMESPACE}--demo-units--field-label`,
  demoUnitsInput: 'partnerbasicinfo-demo-units-count',
}
